/**
 * PurchasesAdapter — the only doorway to IAP (brief §17).
 *
 * The native implementation (RevenueCat, @revenuecat/purchases-capacitor) is
 * wired in Phase 8. Until then — and permanently on web — the stub below
 * reports free tier. stores/entitlement.ts is the only consumer.
 */

export type PurchaseResult =
  | { ok: true }
  | { ok: false; reason: 'cancelled' | 'unavailable' | 'error'; message?: string };

export interface PurchasesAdapter {
  /** Last-known entitlement. Must not throw; default to cached state offline. */
  isPro(): Promise<boolean>;
  purchase(): Promise<PurchaseResult>;
  /** Returns the post-restore entitlement. */
  restore(): Promise<boolean>;
  onChange(cb: (isPro: boolean) => void): void;
}

/** Web (and pre-Phase-8 native dev): purchases are unavailable, always free. */
export class WebPurchasesAdapter implements PurchasesAdapter {
  async isPro(): Promise<boolean> {
    return false;
  }
  async purchase(): Promise<PurchaseResult> {
    return { ok: false, reason: 'unavailable', message: 'Purchases are only available in the iOS and Android apps.' };
  }
  async restore(): Promise<boolean> {
    return false;
  }
  onChange(): void {
    // web entitlement never changes
  }
}

let adapter: PurchasesAdapter | null = null;

export function getPurchasesAdapter(): PurchasesAdapter {
  if (!adapter) {
    // TODO(Phase 8): on Capacitor.isNativePlatform(), install the RevenueCat adapter.
    adapter = new WebPurchasesAdapter();
  }
  return adapter;
}

/** Test seam + native bootstrap. */
export function setPurchasesAdapter(a: PurchasesAdapter | null): void {
  adapter = a;
}
